import { usePresentationContext } from '@mentimeter/question-modules-contexts';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';

export const Screenshot = () => {
  const { useQfa } = usePresentationContext();
  const { totalQuestions, totalUpvotes } = useQfa();
  return (
    <Box>
      <Text
        fontWeight="semiBold"
        color="text"
        lineHeight="heading"
        fontFamily="heading"
        fontSize={13}
      >
        {totalQuestions} {totalQuestions === 1 ? 'question' : 'questions'}
        <br />
        {totalUpvotes} {totalUpvotes === 1 ? 'upvote' : 'upvotes'}
      </Text>
    </Box>
  );
};
